import ComponentHeaderClose from "./HeaderClose";
import CounterInline from "./components/CounterInline/HeaderCloseCounterInline";
import RightButtonCircle from "./components/RightAddon/HeaderCloseRightButtonCircle";
import Subtitle from "./components/Subtitle/HeaderCloseSubtitle";
import Title from "./components/Title/HeaderCloseTitle";

export interface IHeaderCloseExtensions {
    Title: typeof Title;
    CounterInline: typeof CounterInline;
    Subtitle: typeof Subtitle;
    RightButtonCircle: typeof RightButtonCircle;
}

export const HeaderClose: typeof ComponentHeaderClose & IHeaderCloseExtensions =
    Object.assign(ComponentHeaderClose, {
        Title,
        CounterInline,
        Subtitle,
        RightButtonCircle,
    });
